import { ToolDatamatrix } from '../../model/toolDatamatrix.model';
import { ModalComponent } from '../../../shared/components';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToolEngraveComponent } from '@app/tool/components/tool-engrave/tool-engrave.component';
import { Log } from "ng2-logger";
import { ConfirmationModalComponent } from "@components/confirmation-modal/confirmation-modal.component";
import { ToolService } from "@services/tool.service";

@Component({
    selector: 'app-tool-engrave-modal',
    templateUrl: './tool-engrave-modal.component.html',
    styleUrls: ['./tool-engrave-modal.component.scss']
})
export class ToolEngraveModalComponent implements OnInit {
    _logger = Log.create(ToolEngraveModalComponent.name);

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @ViewChild(ToolEngraveComponent, {static: true}) toolEngrave: ToolEngraveComponent;
    @ViewChild(ConfirmationModalComponent, {static: true}) confirmationModal: ConfirmationModalComponent;

    @Input() toolsToEngrave: ToolDatamatrix[] = [];
    @Input() selectedTool;

    @Output() closeModal = new EventEmitter();
    @Output() regenerateDataMatrix = new EventEmitter();

    isConfirmationInProgress = false;

    isOpen = false;

    shouldOpen = false;
    constructor(private toolService: ToolService) {
    }

    ngOnInit() {
    }

    open() {
        this.shouldOpen = true;
        this._logger.info("open:: Opening engrave modal");
        this.isOpen = true;
        this.modal.open();
    }

    close() {
        this.shouldOpen = false;
        this._logger.info("close:: Closing modal");
        this.isOpen = false;
        this.closeModal.emit();
        this.modal.close();
    }

    onModalClose() {
        this.isOpen = false;
    }

    onRegenerateDataMatrix() {
        this.confirmationModal.open();
        this.modal.close();
    }

    onConfirmRegenerate(event: any) {
        const toolToRegenerateDMX =  this.toolsToEngrave.filter(x => x.toolId === this.selectedTool.id)[0];
        this.toolService.regenerateDataMatrix(toolToRegenerateDMX, event).subscribe(
            data => {
                this._logger.info('onConfirmRegenerate:: DataMatrix succesfully regenerated : ', data);
                this.confirmationModal.close();
                this.regenerateDataMatrix.emit(data);
            },
            error => {
                this._logger.info('onConfirmRegenerate:: DataMatrix regenerate error : ', error);
                this.confirmationModal.close();
            }
        )
    }

}
